import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id D0FECA65-0432-4231-AFA5-EDD331188CD6
 * name size-m
 * version: 5.0.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/size-m.svg
 * tags
 */
export const SizeMIcon = createSvgIcon(<><path d="M9 7C7.9 7 7 7.9 7 9V17H9V9H11V16H13V9H15V17H17V9C17 7.9 16.11 7 15 7H9Z" /></>, 'SizeMIcon');
export default SizeMIcon